module.exports = __webpack_public_path__ + "img/ESL_Catalogue_Tile_Image.9991d605.png";